import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) =>
  api.post("/auth/login", { email, password });

export const getMe = () => api.get("/auth/me");

// Users
export const getUsers = () => api.get("/users");
export const createUser = (data) => api.post("/users", data);
export const updateUser = (id, data) => api.patch(`/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/users/${id}`);
export const getRoles = () => api.get("/roles");

// Categories
export const getCategories = () => api.get("/categories");
export const createCategory = (data) => api.post("/categories", data);
export const deleteCategory = (id) => api.delete(`/categories/${id}`);

// Equipment
export const getEquipment = () => api.get("/equipment");
export const getEquipmentById = (id) => api.get(`/equipment/${id}`);
export const getEquipmentHistory = (id) => api.get(`/equipment/${id}/history`);
export const createEquipment = (data) => api.post("/equipment", data);
export const updateEquipment = (id, data) => api.patch(`/equipment/${id}`, data);
export const deleteEquipment = (id) => api.delete(`/equipment/${id}`);
export const uploadEquipmentImage = (id, data) => api.post(`/equipment/${id}/images`, data);
export const deleteEquipmentImage = (id, imageId) => api.delete(`/equipment/${id}/images/${imageId}`);

// Employees
export const getEmployees = () => api.get("/employees");
export const createEmployee = (data) => api.post("/employees", data);
export const updateEmployee = (id, data) => api.patch(`/employees/${id}`, data);
export const deleteEmployee = (id) => api.delete(`/employees/${id}`);

// Loans
export const getLoans = () => api.get("/loans");
export const createLoan = (data) => api.post("/loans", data);
export const returnLoan = (id, data) => api.patch(`/loans/${id}/return`, data);
export const deleteLoan = (id) => api.delete(`/loans/${id}`);
export const getLoanPdf = (id) => `${API_URL}/loans/${id}/pdf`;

// Sales
export const getSales = () => api.get("/sales");
export const createSale = (data) => api.post("/sales", data);
export const deleteSale = (id) => api.delete(`/sales/${id}`);

// Reports
export const getReportsSummary = () => api.get("/reports/summary");
export const getEquipmentByCategory = () => api.get("/reports/equipment-by-category");
export const getRecentActivity = () => api.get("/reports/recent-activity");

export default api;
